import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.25 9.063c.957 0 1.75.792 1.75 1.75V13c0 .984-.793 1.75-1.75 1.75H1.75C.766 14.75 0 13.984 0 13v-2.188c0-.957.766-1.75 1.75-1.75H3.2l1.312 1.313H1.75a.45.45 0 0 0-.438.438V13c0 .246.192.438.438.438h10.5a.45.45 0 0 0 .438-.438v-2.188a.47.47 0 0 0-.438-.437H9.46l1.313-1.313h1.477Zm-.438 2.843c0 .383-.3.656-.656.656a.632.632 0 0 1-.656-.656c0-.355.273-.656.656-.656.356 0 .656.3.656.656ZM6.535 10.84 2.816 7.12a.599.599 0 0 1 0-.902.599.599 0 0 1 .903 0l2.625 2.597v-7.41c0-.355.273-.656.656-.656.355 0 .656.3.656.656v7.41l2.598-2.597a.599.599 0 0 1 .902 0 .599.599 0 0 1 0 .902L7.437 10.84A.544.544 0 0 1 7 11.03c-.191 0-.355-.054-.465-.191Z"
	})]
});
const ForwardRef = forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
